export default {
  apiVersion: 2,
  development: {
    accessToken: 'dc301d8d9bc9eb60b4be61e4bb5e0699',
    url: 'http://saffran.dev.moya.is/_/moya/pilot/api',
  },
  staging: {
    accessToken: 'dc301d8d9bc9eb60b4be61e4bb5e0699',
    url: 'https://api.saffran.is/_/moya/pilot/api',
  },
  production: {
    accessToken: 'dc301d8d9bc9eb60b4be61e4bb5e0699',
    url: 'https://api.saffran.is/_/moya/pilot/api',
  },
};
